<script setup lang="ts">
import { ref } from "vue";
import { build_settings } from "../../../assets/custom/settings";
import { locale } from "../../../locale";
import { isSelfAdmin } from "../../../states/adminsState";
import { recordState } from "../../../states/recordState";
import { roomState } from "../../../states/room";
import ToolTip from "../../ToolTip.vue";
import RecordingButton from "./RecordingButton.vue";
import RecordingIcon from "../../icons/RecordingIcon.vue";

const rf = ref<HTMLElement | null>(null);
const rffree = ref<HTMLElement | null>(null);
</script>

<template>
  <RecordingButton
    v-if="
      isSelfAdmin &&
      (roomState.tarif === 'PAY' || build_settings.disable_tariff_feature)"
  />
  <span
    class="recording"
    ref="rf"
    v-else-if="
      (!isSelfAdmin || roomState.tarif === 'FREE') &&
      recordState.recording
    "
  >
    <RecordingIcon />
    <ToolTip :placement="'top'" :reference="rf"
      >{{ locale.recording }}
    </ToolTip>
  </span>
  <span
    class="recording-free"
    ref="rffree"
    v-else-if="
      isSelfAdmin &&
      roomState.tarif === 'FREE' &&
      !build_settings.disable_tariff_feature
    "
  >
    <RecordingIcon />
    <ToolTip :placement="'top'" :reference="rffree"
      >{{ locale.recording_tarif }}
    </ToolTip>
  </span>
</template>
<style scoped>
.recording {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  background-color: #d51f26;
}

.recording-free {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  background-color: rgba(73, 73, 73, 0.85);
}
</style>
